















import Vue from 'vue';
import customerClient from '../../../customer/apis';
import format from '../../../customer/components/filter/makeCustomerQuery';
import customerVuex from '../../../customer/vuex/common';
import { resetCustomerFilter } from '@/customer/models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      total: 0,
      loaded: false,
    };
  },
  props: {
    isAllFans: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setTotal() {
      let cf = this.customerFilter;
      if (this.isAllFans) {
        cf = resetCustomerFilter();
      }
      const query = format.mkFilterQueries(cf);
      customerClient.getList(query).success((r: any) => {
        this.total = r.total;
        this.loaded = true;
        this.$emit('setTotal', r.total);
      });
    },
  },
  mounted() {
    this.setTotal();
  },
  watch: {
    customerFilter: {
      handler: function(newVal, oldVal) {
        this.setTotal();
      },
      deep: true,
    },
  },
});
